<template>
    <el-row>
        <el-col :span="6" v-show="eshopopee != -1&&eshopopeeVisible===true">
            <cardContactMethodIcon  url="/static/images/icon_e-shopopee_logo.png" @click="clickChatBtn" />
        </el-col>


        <el-col :span="6" v-for="(v, i) in recordList" :key="v.id">
            <cardContactMethodIcon :url="v.addinfo2" @click="clickContactIcon(v)" />
        </el-col>

        <el-dialog
                v-model="QrcodeVisible"
                :title="QrcodeTitle"
                :width="300"
                align-center
                destroy-on-close
                :close-on-click-modal="false"
                :close-on-press-escape="false"
                @closed="submitClose"
        >
            <img :src="QrcodeUrl" style="width: 250px; height: 250px" />
        </el-dialog>
    </el-row>
</template>

<script setup>
    import {reactive, onMounted, onBeforeMount, ref, getCurrentInstance, toRef, inject} from "vue";
    import cardContactMethodIcon from "@/components/shopopee/card/cardContactMethodIcon"
    import record7Api from "@/request/record7Api";
    import myUtil from "@/util/util";
    import record1Api from "@/request/record1Api";
    import {useUserinfo} from "@/stores/userinfo";

    //響應機制的userinfo
    const userInfoRef = toRef(useUserinfo())

    const props = defineProps(["card", "recordIdStr","eshopopee"])
    const emits = defineEmits(["goWebsite"])

    const { proxy } = getCurrentInstance()

    const i18n = inject("i18n")

    const QrcodeVisible = ref(false)
    const QrcodeTitle = ref("")
    const QrcodeUrl = ref(null)

    const imgList = reactive({
        img0: "/static/images/icon_e-shopopee_logo.png",
        img1: "/static/images/icon_whatsapp.png"
    })

    const eshopopeeVisible = ref(false)

    const hrefList = reactive({
        url0: null,
        url1: null,
        url2: null,
        url3: null,
    })

    const recordList = ref([])

    function getContactList(){
      eshopopeeVisible.value = false;
        const request = record7Api.getAdditionalrecord7List
        const params = request.getParams()

        params.group = props.recordIdStr.split(",")

        request.send(params, (res) => {

          eshopopeeVisible.value =true;
            if (res.code == 200){
                recordList.value = res.detail

              if(props.eshopopee ==-1){
                 if(recordList.value.length==1){
                   eshopopeeVisible.value = false
                   clickContactIcon(recordList.value[0])
                 }
              }else{
                if(recordList.value.length<1){
                  eshopopeeVisible.value = false
                  clickChatBtn()
                }
              }
            }else{
                myUtil.alertError(res.msg)
            }

        })

    }

    function clickContactIcon(obj){

        if (obj.addinfo1 == 0){
            if (myUtil.isNotEmpty(obj.addremark1)){
                myUtil.confirmSuccess(`${i18n.tkey("lang_about_jump_to")} ${obj.addremark1}`, () => {
                    myUtil.goURLNewWindow(obj.addremark1, "chatMethod")
                    // location.href = obj.addremark1
                })
            }
        }else{
            if (myUtil.isNotEmpty(obj.addinfo3)){
                QrcodeVisible.value = true
                QrcodeTitle.value = obj.addinfo4
                QrcodeUrl.value = proxy.$ShopopeeUrl + obj.addinfo3
            }

        }
    }

    function submitClose(){
        QrcodeUrl.value = null
        QrcodeTitle.value = ""
    }

    function clickChatBtn(){
        emits("goWebsite")
    }


    onBeforeMount(() => {
        if (null != props.card && null != props.recordIdStr){
            hrefList.url0 = `${proxy.$ShopopeeUrl}receive/phone/${props.card.id}`
            hrefList.url1 = `tel:${props.card.telephone}`
            hrefList.url2 = `mailto:${props.card.email}`
            hrefList.url3 = `javascript: void(0)`

            getContactList()
        }
    })

    onMounted(() => {

    })

</script>

<style scoped>

</style>